import React from 'react';
import {MessageView} from '../../../@crema';
import {useSelector} from 'react-redux';
import {v4 as uuid} from 'uuid';

interface InfoViewProps {}

const InfoView: React.FC<InfoViewProps> = () => {
  const common = useSelector((store: any) => store.common);
  const {message, error} = common;

  const showMessage = () => {
    return (
      <MessageView
        variant='success'
        message={message.toString()}
        number={uuid()}
      />
    );
  };

  const showError = () => {
    return (
      <MessageView variant='error' message={error.toString()} number={uuid()} />
    );
  };

  return (
    <>
      {message && showMessage()}
      {error && showError()}
    </>
  );
};

export default InfoView;
